export default class InputMoney extends HTMLElement {
	constructor() {
		super();

		this.input = document.createElement('input');
		this.input.type = 'text';
		this.input.value = this.formatValue(this.value);

		this.includeDollarSign = false;
		this.includePercentage = false;
	}

	get value() {
		return this.cleanValue(this.input.value)?.toString() ?? '';
	}

	set value(value) {
		this.input.value = this.formatValue(value);
	}

	get disabled() {
		return this.input.disabled;
	}

	set disabled(disabled) {
		this.input.disabled = disabled;
	}

	connectedCallback() {
		this.input.disabled = this.disabled;
		this.input.value = this.formatValue(this.value);
		this.appendChild(this.input);

		this.input.addEventListener('focus', () => {
			this.input.value = this.cleanValue(this.value)?.toString() ?? '';
			this.input.select();
		});

		this.input.addEventListener('blur', () => {
			this.value = this.formatValue(this.value);
			this.dispatchEvent(new CustomEvent('change', { target: this }));
		});
	}

	cleanValue(value) {
		const cleaned = parseFloat(value.replace(/[^0-9.-]/g, ''));
		return isNaN(cleaned) ? null : cleaned;
	}

	formatValue(value) {
		// Format to 2 decimal places and add thousands separator
		const formatted = this.cleanValue(value)?.toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});

		if (!formatted) {
			return '';
		}

		if (this.includeDollarSign) {
			return `$${formatted}`;
		}

		if (this.includePercentage) {
			return `${formatted}%`;
		}

		return formatted;
	}

	disconnectedCallback() {
		// Nothing to do yet
	}
}

export function defineInputMoney() {
	if (!customElements.get('input-money')) {
		customElements.define('input-money', InputMoney);
	}
}
